import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostListener,
  input,
  InputSignal,
  Output,
  signal,
  WritableSignal
} from '@angular/core';
import { SzIconComponent } from '../../display/sz-icon';
import { SzActionMenuItem } from './sz-action-menu.types';

@Component({
  selector: 'sz-action-menu',
  templateUrl: './sz-action-menu.component.html',
  styleUrls: ['./sz-action-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [SzIconComponent]
})
export class SzActionMenuComponent {
  readonly items: InputSignal<readonly SzActionMenuItem[]> = input.required<readonly SzActionMenuItem[]>();
  readonly ariaLabel: InputSignal<string> = input<string>('Actions');
  readonly blurBackdrop: InputSignal<boolean> = input<boolean>(false);

  @Output() readonly itemSelect: EventEmitter<string> = new EventEmitter<string>();

  readonly open: WritableSignal<boolean> = signal<boolean>(false);

  toggle(): void {
    this.open.update((value: boolean): boolean => !value);
  }

  close(): void {
    this.open.set(false);
  }

  onSelect(id: string): void {
    this.close();
    this.itemSelect.emit(id);
  }

  @HostListener('document:keydown.escape')
  onEscape(): void {
    if (this.open()) {
      this.close();
    }
  }
}
